import { useMemo } from 'react';
import { usePreferences } from '../context/PreferencesContext';
import { t as translate } from './messages';

export function useI18n() {
  const ctx = usePreferences();
  const language = ctx?.language || 'fr';

  return useMemo(
    () => ({
      lang: language,
      t: (path) => {
        try {
          return translate(language, path);
        } catch {
          return path;
        }
      },
    }),
    [language]
  );
}
